module.exports = __webpack_public_path__ + "static/media/star.6e9ea47e.svg";